module.exports = __webpack_public_path__ + "img/144_1.be21f328.png";